import { EmptyState, Flex, Heading, Icons, Paragraph } from "@ir/ui";
import { PageContent } from "@src/presentation/components/Layout/common";

const ErrorFallback = () => {
  return (
    <PageContent>
      <Flex align="center" justifyContent="center" style={{ height: "100vh" }}>
        <EmptyState
          className="bg-white border-1 border-color-grey-25 px-4 py-5 m-4"
          icon={Icons.InfoOctagon}
          title={
            <Heading level={6} className="text-grey-700 font-bold mt-3">
              Something went wrong
            </Heading>
          }
          description={
            <Paragraph className="text-grey-500 font-regular mb-0">
              Please try again later.
            </Paragraph>
          }
        />
      </Flex>
    </PageContent>
  );
};

export default ErrorFallback;
